import { render, staticRenderFns } from "./CompareSongs.vue?vue&type=template&id=4cceb1f0&scoped=true&"
import script from "./CompareSongs.vue?vue&type=script&lang=ts&"
export * from "./CompareSongs.vue?vue&type=script&lang=ts&"
import style0 from "./CompareSongs.vue?vue&type=style&index=0&id=4cceb1f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cceb1f0",
  null
  
)

export default component.exports